{
  "videos": [
    {
      "title": "1.1 Git – Введение – Что такое Git?",
      "url": "https://www.youtube.com/watch?v=W4hoc24K93E&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb"
    },
    {
      "title": "2.1 Git – Основы – Конфигурация",
      "url": "https://www.youtube.com/watch?v=hWiqh6YUUS8&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=3"
    },
    {
      "title": "2.2 Git – Основы – Создание репозитория, первый коммит",
      "url": "https://www.youtube.com/watch?v=j2F77U-2FuQ&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=4"
    },
    {
      "title": "2.3 Git – Основы – Git и права на файлы",
      "url": "https://www.youtube.com/watch?v=KrlYu1ToS-o&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=5"
    },
    {
      "title": "2.4 Git – Основы – Git show, кто такие автор и коммиттер",
      "url": "https://www.youtube.com/watch?v=_qWWtXu07GI&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=6"
    },
    {
      "title": "2.5 Git – Основы – Добавление файлов и директорий, git status",
      "url": "https://www.youtube.com/watch?v=xzEMA7rzN3Y&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=7"
    },
    {
      "title": "2.6 Git – Основы – Хороший коммит",
      "url": "https://www.youtube.com/watch?v=WlIzoLK46is&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=8"
    },
    {
      "title": "2.7 Git – Основы – Зачем нужен индекс?",
      "url": "https://www.youtube.com/watch?v=75TOiisShWw&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=9"
    },
    {
      "title": "2.8 Git – Основы – Коммиты без git add",
      "url": "https://www.youtube.com/watch?v=UX7O3oekwFA&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=10"
    },
    {
      "title": "2.9 Git – Основы – Удаление и переименование файлов",
      "url": "https://www.youtube.com/watch?v=W71P4I0MGr0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=11"
    },
    {
      "title": "3.1 Git – Ветки – Введение",
      "url": "https://www.youtube.com/watch?v=aSohh-m5vJY&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=12"
    },
    {
      "title": "3.2 Git – Ветки – Создание и переключение",
      "url": "https://www.youtube.com/watch?v=ydtgQSaUzw0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=13"
    },
    {
      "title": "3.3 Git – Ветки – Команда checkout при незакоммиченных изменениях",
      "url": "https://www.youtube.com/watch?v=KxKjBneF_NI&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=14"
    },
    {
      "title": "3.4 Git – Ветки – Перенос незакоммиченных изменений",
      "url": "https://www.youtube.com/watch?v=mlxmxsBzIMs&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=15"
    },
    {
      "title": "3.5 Git – Ветки – Перенос веток \"вручную\"",
      "url": "https://www.youtube.com/watch?v=6oZG-pAeHRE&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=16"
    },
    {
      "title": "3.6 Git – Ветки – Состояние отделённой HEAD",
      "url": "https://www.youtube.com/watch?v=g0GgtqlhHaw&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=17"
    },
    {
      "title": "3.7 Git – Ветки – Восстановление предыдущих версий файлов",
      "url": "https://www.youtube.com/watch?v=3z-LjQacu2Q&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=18"
    },
    {
      "title": "3.8 Git – Ветки – Просмотр истории и старых файлов, символы ~, ^, @, поиск с :/",
      "url": "https://www.youtube.com/watch?v=l-sTQBr3rXY&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=19"
    },
    {
      "title": "3.9 Git – Ветки – Слияние веток \"перемоткой\"",
      "url": "https://www.youtube.com/watch?v=g--N6QHbt6Q&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=20"
    },
    {
      "title": "3.10 Git – Ветки – Удаление веток",
      "url": "https://www.youtube.com/watch?v=yFVPNYSTlLQ&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=21"
    },
    {
      "title": "3.11 Git – Ветки – История переключений веток: лог ссылок reflog",
      "url": "https://www.youtube.com/watch?v=FxyGx_XTRhA&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=22"
    },
    {
      "title": "4.1 Git – Удаление \"лишних\" файлов и незакоммиченных изменений",
      "url": "https://www.youtube.com/watch?v=h9kYvAQoXjo&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=23"
    },
    {
      "title": "5.1 Git – Reset – Жесткий reset --hard: отмена изменений, удаление коммитов",
      "url": "https://www.youtube.com/watch?v=DMncFUqzDuM&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=24"
    },
    {
      "title": "5.2 Git – Reset – Мягкий reset --soft: замена и объединение коммитов",
      "url": "https://www.youtube.com/watch?v=bUdLmdSMm7E&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=25"
    },
    {
      "title": "5.3 Git – Reset – Правка последнего коммита: commit --amend",
      "url": "https://www.youtube.com/watch?v=Hho9WBgWil0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=26"
    },
    {
      "title": "5.4 Git – Reset – Смешанный reset (без флагов), сравнение видов reset",
      "url": "https://www.youtube.com/watch?v=r1oUTfqKXac&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=27"
    },
    {
      "title": "5.5 Git – Reset – Таблица с действиями reset",
      "url": "https://www.youtube.com/watch?v=hb-x1SJB43s&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=28"
    },
    {
      "title": "6.1 Git – Просмотр – Сравнение коммитов, веток и не только: git diff",
      "url": "https://www.youtube.com/watch?v=1oExHLJXBIg&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=29"
    },
    {
      "title": "6.2 Git – Просмотр – Вывод истории: git log, форматирование коммитов",
      "url": "https://www.youtube.com/watch?v=Oim9dbpbCMc&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=30"
    },
    {
      "title": "6.3 Git – Просмотр – Диапазоны коммитов для git log и не только",
      "url": "https://www.youtube.com/watch?v=nRYSu3wbNXo&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=31"
    },
    {
      "title": "6.4 Git – Просмотр – Вывод git log коммитов, меняющих нужный файл",
      "url": "https://www.youtube.com/watch?v=7A68GxROZ2I&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=32"
    },
    {
      "title": "6.5 Git – Просмотр – Поиск в истории, фильтры для git log",
      "url": "https://www.youtube.com/watch?v=lhrchh5dqH0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=33"
    },
    {
      "title": "6.6 Git – Просмотр – Кто написал эту строку? git blame",
      "url": "https://www.youtube.com/watch?v=o9du71FpLLM&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=34"
    },
    {
      "title": "7.1 Git – Слияние – \"Истинное\" слияние и разрешение конфликтов в git merge",
      "url": "https://www.youtube.com/watch?v=PXK1hIifpWU&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=35"
    },
    {
      "title": "7.2 Git – Слияние – Коммит слияния, дальнейшие слияния",
      "url": "https://www.youtube.com/watch?v=EJKw_qW5pgI&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=36"
    },
    {
      "title": "7.3 Git – Слияние – Отмена слияния",
      "url": "https://www.youtube.com/watch?v=TEsjp1eDLx4&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=37"
    },
    {
      "title": "7.4 Git – Слияние – Семантические конфликты и их разрешение",
      "url": "https://www.youtube.com/watch?v=h4jxghOE9e0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=38"
    },
    {
      "title": "7.5 Git – Слияние – Полезный приём: сохранение веток с флагом --no-ff",
      "url": "https://www.youtube.com/watch?v=AHjS9MWsNm0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=40"
    },
    {
      "title": "7.6 Git – Слияние – Создание коммита из ветки: merge --squash",
      "url": "https://www.youtube.com/watch?v=1v-dxpobjlY&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=40"
    },
    {
      "title": "8.1 Git – Копирование коммитов – Копирование коммитов: cherry-pick",
      "url": "https://www.youtube.com/watch?v=TZJxBSfR0NE&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=41"
    },
    {
      "title": "9.1 Git – Перемещение коммитов – Перебазирование вместо слияния: rebase",
      "url": "https://www.youtube.com/watch?v=jxwPgfmutjs&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=42"
    },
    {
      "title": "9.2 Git – Перемещение коммитов – Rebase и merge: сравнение подходов",
      "url": "https://www.youtube.com/watch?v=Z3Q2RaEUQO0&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=43"
    },
    {
      "title": "9.3 Git – Перемещение коммитов – Rebase с тестами, флаг -x",
      "url": "https://www.youtube.com/watch?v=dnT8YzpqEYA&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=44"
    },
    {
      "title": "9.4 Git – Перемещение коммитов – Перенос части ветки, rebase --onto",
      "url": "https://www.youtube.com/watch?v=t_sPfT8m0s8&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=45"
    },
    {
      "title": "9.5 Git – Перемещение коммитов – Перебазирование слияний, --rebase-merges",
      "url": "https://www.youtube.com/watch?v=P89rsHliIpM&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=46"
    },
    {
      "title": "9.6 Git – Перемещение коммитов – Интерактивное перебазирование, rebase -i",
      "url": "https://www.youtube.com/watch?v=4K9X1Aa1nvA&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=47"
    },
    {
      "title": "9.7 Git – Перемещение коммитов – Исправляем коммит посередине ветки: autosquash",
      "url": "https://www.youtube.com/watch?v=exYHemsk1V8&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=48"
    },
    {
      "title": "10.1 Git – Отмена коммитов через revert – Обратные коммиты, revert",
      "url": "https://www.youtube.com/watch?v=FcwQrN9XOwU&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=49"
    },
    {
      "title": "10.2 Git – Отмена коммитов через revert – Отмена слияния через revert",
      "url": "https://www.youtube.com/watch?v=aRbOsagYs8w&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=50"
    },
    {
      "title": "10.3 Git – Отмена коммитов через revert – Повторное слияние с rebase",
      "url": "https://www.youtube.com/watch?v=3HDSLArx3qw&list=PLDyvV36pndZFHXjXuwA_NywNrVQO0aQqb&index=51"
    }
  ],
  "materials": [
    {
      "title": "Markdown Cheatsheet",
      "url": "https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet"
    }
  ]
}
